import { AlertModalLayout, Button, GeneralFormError } from '@ui-components/neo.tax';
import { ReactElement, useEffect, useState } from 'react';

import { ModalContainer } from './delete-confirmation-layout.styled';

interface DeleteConfirmationLayoutProps {
  close: () => void;
  deleteDisabled?: boolean;
  deleteMutation: () => Promise<void>;
  loading: boolean;
  errorMessage?: string;
  title: string;
  description: string | React.ReactElement;
  confirmButtonId?: string;
}

export const DeleteConfirmationLayout = ({
  close,
  confirmButtonId,
  deleteDisabled = false,
  deleteMutation,
  description,
  errorMessage: errorMessageProp,
  loading,
  title,
}: DeleteConfirmationLayoutProps): ReactElement => {
  const [errorMessage, setErrorMessage] = useState<string | ReactElement>();

  const onSubmit = async (): Promise<void> => {
    try {
      setErrorMessage(undefined);
      await deleteMutation();
      close();
    } catch (error) {
      setErrorMessage(
        (errorMessage) =>
          errorMessage ||
          (error instanceof Error && error.message) ||
          'An unexpected error occurred. Please try again.',
      );
    }
  };

  const onClickCancel = (): void => {
    close();
    setErrorMessage(undefined);
  };

  useEffect(
    function watchErrorMessageProp() {
      setErrorMessage(errorMessageProp);
    },
    [errorMessageProp],
  );

  return (
    <ModalContainer>
      <AlertModalLayout
        title={title}
        copy={typeof description === 'string' ? description : ''}
        trailingContent={
          <>
            <Button size="base" variant="white" rounded="regular" onClick={onClickCancel}>
              Cancel
            </Button>
            <Button
              id={confirmButtonId}
              disabled={deleteDisabled || loading}
              rounded="regular"
              size="base"
              type="submit"
              variant="rsbry"
              onClick={onSubmit}
            >
              {loading ? 'Deleting...' : 'Confirm'}
            </Button>
          </>
        }
      >
        {typeof description !== 'string' ? description : <></>}
        <GeneralFormError error={!!errorMessage}>{errorMessage}</GeneralFormError>
      </AlertModalLayout>
    </ModalContainer>
  );
};
